import styled from "styled-components";

export const Container = styled.div`
  padding: 64px 32px 128px;
  @media only screen and (max-device-width: 812px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  padding: 0 48px;
  margin: 0 auto;
  max-width: 920px;

  div.ant-typography {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }

  h3 {
    color: var(--velotax-font-color);
  }

  span.link {
    cursor: pointer;
    color: var(--ant-primary-color);
  }

  .ant-typography:not(h1) {
    text-align: justify;
  }

  a.ant-typography,
  .ant-typography a {
    color: var(--ant-primary-color);
  }

  .ant-typography i strong {
    font-size: 13px;
    letter-spacing: 0.625px;
    word-spacing: 0.625px;
  }

  iframe {
    max-width: 100%;
  }

  .ant-list {
    margin-bottom: 1em;
  }

  .ant-collapse,
  .ant-collapse.ant-collapse-borderless {
    border-radius: 8px;
    background-color: transparent;
    border: 1px solid var(--ghost);
    .ant-collapse-item {
      .ant-collapse-header {
        padding: 16px;
        font-size: 1.125rem;
        color: var(--velotax-font-color);
        .ant-collapse-arrow {
          font-size: 0.875rem;
        }
      }
      .ant-collapse-content {
        color: var(--velotax-font-color);
        border-bottom: 1px solid;
        border-color: var(--ghost);
      }
    }

    .ant-collapse-item:last-child {
      .ant-collapse-content {
        border-bottom: none;
        border-radius: 0 0 8px 8px;
      }
    }
  }

  @media only screen and (max-device-width: 812px) {
    padding: 24px 24px 128px;
    border-radius: 0;
  }
`;
